import { createSelector } from '@reduxjs/toolkit';

import { getPageNumberAndSizeKey } from '@/redux/modules/otherCategories/otherCategories';
import { GlobalState } from '@/redux/store';
import { OtherCategory } from '@/types/categories/categories';

const stateSelector = (state: Partial<GlobalState>) => state;
const otherCategoriesSlice = createSelector(stateSelector, (state) => state.otherCategories);

export const createOtherCategoriesByPageSelector = (pageNumber: number, pageSize: number) =>
    createSelector(
        otherCategoriesSlice,
        ({ byPageNumberAndSize }): OtherCategory[] | undefined =>
            byPageNumberAndSize[getPageNumberAndSizeKey(pageNumber, pageSize)]
    );

export const otherCategoriesTotalResultsSelector = createSelector(
    otherCategoriesSlice,
    ({ totalResults }) => totalResults
);
